<template>
  <div>
    <el-tabs class="glo_tabs" type="border-card" v-model="activeName" @tab-click="tabsClick">
      <!-- =====第一步发车类型===== -->
      <el-tab-pane label="第一步发车类型" name="one" :disabled="disabled1">
        <div>
          <el-form :model="oneDatas" :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'" label-position="left">
            <el-form-item class="queryItems" label="配载类型:">
              <el-select filterable clearable v-model="oneDatas.departureType" placeholder="请输入" @change="cahngeDepType">
                <el-option v-for="item in departure_type_list" :key="item.statusVal" :label="item.showName" :value="item.statusVal"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="queryItems" label="车型:" v-if="
                oneDatas.departureType == 'zheng_chang_fa_che:departure_type'
              ">
              <el-select filterable clearable v-model="oneDatas.carTypeConfDictId" placeholder="请输入" @change="changeCarType">
                <el-option v-for="item in car_type_list" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="queryItems itemPch" label="关联主发车批次号:" v-if="
                oneDatas.departureType == 'yan_tu_zhuang_huo:departure_type'
              ">
              <el-input placeholder="请输入" clearable v-model="oneDatas.parentNumber"></el-input>
            </el-form-item>
          </el-form>
          <el-button class="glo_bgcMainColor creatBtns" @click="createRenWu()">生成任务</el-button>
        </div>
      </el-tab-pane>
      <!-- =====第二步添加任务===== -->
      <el-tab-pane label="第二步添加任务" name="two" :disabled="disabled2">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="nextStep2()">下一步</el-button>
          </div>
          <queryBtns :MoreConditions="MoreConditions" @clerBtns="clerBtns" :showMoreBtns="false" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
          <el-button class="glo_btnItems tabbleSetting" type="primary" @click="myModel()">表格设置</el-button>
        </div>
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form :model="queryData" :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'" label-position="left">
            <!-- 时间组件 -->
            <el-form-item class="queryItemsTimes">
              <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
            </el-form-item>

            <el-form-item class="queryItems" label="运输计划:">
              <el-select filterable clearable v-model="queryData.transportPlan" placeholder="请输入" @focus="getTransPlan" @change="queryBtn_ok">
                <el-option v-for="(item, index) in transport_plan_list" :key="index" :label="item.showName" :value="item.statusVal"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="queryItems" label="客户名称:">
              <el-select filterable clearable v-model="queryData.customerName" placeholder="请输入" remote :remote-method="getCustomerNames" @focus="getCustomerList()" @change="queryBtn_ok">
                <el-option v-for="(item, index) in CustomerList" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="queryItems" label="装货地址:">
              <el-input placeholder="请输入" clearable v-model="queryData.taskStartAllAddress" @keyup.enter.native="queryBtn_ok"></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="卸货地址:">
              <el-input placeholder="请输入" clearable v-model="queryData.taskEndAllAddress" @keyup.enter.native="queryBtn_ok"></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="运输方式:">
              <el-select filterable clearable v-model="queryData.transportMethod" placeholder="请输入" @focus="getTransportMethod" @change="queryBtn_ok">
                <el-option v-for="(item, index) in transport_method_list" :key="index" :label="item.showName" :value="item.statusVal"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="queryItems waybillNumbersss" label="运单号:">
              <el-input placeholder="请输入运单号;多个运单号用逗号','隔开" clearable v-model="queryData.waybillNumber" @keyup.enter.native="queryBtn_ok"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 穿梭表格 -->
        <div class="ShuttleTable">
          <!-- 左边 -->
          <div class="leftTable">
            <!-- 表格 -->
            <div class="glo_Table">
              <div class="tabTips">未选择</div>
              <el-table :height="tableHeigth2" header-align="center" ref="mytable" @row-click="rowclick" :data="tableDataLeft" border stripe @selection-change="handleSelectionChange">
                <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
                <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
                <template v-for="(item, index) in myTableHeardLeft">
                  <!-- 某个字段需要单独操作  例如点击可以跳转 -->
                  <el-table-column
                    v-if="item.field == 'goodsNames' && item.isShow"
                    :key="index"
                    :label="item.name"
                    :prop="item.field"
                    align="center"
                    sortable
                    :show-overflow-tooltip="true"
                    :min-width="item.width"
                    :data-isTotal="item.isTotal"
                  >
                    <template slot-scope="scope">
                      <div class="linkTabel" @click.stop="getGoodsNameDetails(scope.row)">货物明细</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :key="index"
                    :label="item.name"
                    :prop="item.field"
                    align="center"
                    sortable
                    :show-overflow-tooltip="true"
                    :min-width="item.width"
                    :data-isTotal="item.isTotal"
                    v-else-if="item && item.isShow"
                  ></el-table-column>
                </template>
              </el-table>
              <!-- 分页 -->
              <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
            </div>
          </div>
          <!-- 中间按钮 -->
          <div class="centerBtns">
            <el-button class="glo_btnItems" type="primary" @click="toRight()">
              向右移
              <i class="el-icon-arrow-right"></i>
            </el-button>
            <el-button class="glo_btnItems" type="primary" @click="toLeft()">
              <i class="el-icon-arrow-left"></i>向左移
            </el-button>

            <el-button class="glo_btnItems" type="primary" @click="nextStep2()">预览</el-button>
            <!-- <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="nextStep(2)"
              >跳转路线
            </el-button>-->
          </div>
          <!-- 右边 -->
          <div class="rightTable">
            <!-- 表格 -->
            <div class="glo_Table">
              <div class="tabTips" style="color: #ef7c0a">已选择</div>
              <el-table :height="tableHeigth2" header-align="center" ref="mytable2" @row-click="rowclick2" :data="tableDataRight" border stripe @selection-change="handleSelectionChange2">
                <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
                <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
                <template v-for="(item, index) in myTableHeardLeft">
                  <el-table-column
                    v-if="item.field == 'goodsNames' && item.isShow"
                    :key="index"
                    :label="item.name"
                    :prop="item.field"
                    align="center"
                    sortable
                    :show-overflow-tooltip="true"
                    :min-width="item.width"
                    :data-isTotal="item.isTotal"
                  >
                    <template slot-scope="scope">
                      <div class="linkTabel" @click.stop="getGoodsNameDetails(scope.row)">货物明细</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :key="index"
                    :label="item.name"
                    :prop="item.field"
                    align="center"
                    sortable
                    :show-overflow-tooltip="true"
                    :min-width="item.width"
                    :data-isTotal="item.isTotal"
                    v-else-if="item && item.isShow"
                  ></el-table-column>
                </template>
              </el-table>
              <!-- 分页 -->
              <!-- <paging
                ref="pags"
                :pageNum="pageStart2"
                :total="pageCount2"
                :size="pageTotal2"
                @handleSizeChange="handleSizeChange2"
                @handleCurrentChange="handleCurrentChange2"
              >
              </paging>-->
            </div>
          </div>
        </div>
      </el-tab-pane>
      <!-- =====第三步配载预览===== -->
      <el-tab-pane label="第三步配载预览" name="three" :disabled="disabled3">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList3">
          <div class="glo_btnList_left">
            <el-button v-if="!disabled2" class="glo_btnItems glo_bgcMainColor" @click="nextStep3()">保存并下一步</el-button>
            <el-button v-if="!disabled2" class="glo_btnItems" @click="nextStep(1)">返回上一步</el-button>
            <!-- <el-button class="glo_btnItems" @click="printClick"
              >打印
            </el-button>-->
            <!-- <el-button class="glo_btnItems" @click="nextStep(3)"
              >刷新
            </el-button>-->
          </div>
        </div>
        <!-- 打印域 -->
        <div ref="print">
          <!-- 预览详情 -->
          <div class="detailsBox">
            <div class="item">
              <div class="dItemLabel">发车批次号:</div>
              <div class="dItemVal">{{ number_s }}</div>
            </div>
            <div class="item">
              <div class="dItemLabel">车型:</div>
              <div class="dItemVal">{{ CarTypeName }}</div>
              <div class="ditemBtn" @click="updateCarType()">更换</div>
            </div>
            <!-- <div class="item">
            <div class="dItemLabel">最大载重:</div>
            <div class="dItemVal">10吨</div>
          </div>
          <div class="item">
            <div class="dItemLabel">最大体积:</div>
            <div class="dItemVal">10吨</div>
          </div>
          <div class="item">
            <div class="dItemLabel">车牌号:</div>
            <div class="dItemVal">qb6666</div>
          </div>
          <div class="item">
            <div class="dItemLabel">司机:</div>
            <div class="dItemVal">大风歌手打</div>
          </div>
          <div class="item">
            <div class="dItemLabel">押运员:</div>
            <div class="dItemVal">大哥哥</div>
            </div>-->
          </div>
          <!-- 任务表格 -->
          <!-- <div class="chongTu">!含有冲突品类商品</div> -->
          <div class="glo_Table">
            <el-table header-align="center" :data="tableDataRight" border stripe show-summary :summary-method="getSummaries">
              <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
              <template v-for="(item, index) in myTableHeardLeft2">
                <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :min-width="item.width"
                  :show-overflow-tooltip="true"
                  :data-isTotal="item.isTotal"
                  v-if="item && item.isShow"
                ></el-table-column>
              </template>
            </el-table>

            <!-- 分页 -->
            <!-- <paging
              ref="pags"
              :pageNum="pageStart2"
              :total="pageCount2"
              :size="pageTotal2"
              @handleSizeChange="handleSizeChange2"
              @handleCurrentChange="handleCurrentChange2"
            >
            </paging>-->
          </div>
        </div>
      </el-tab-pane>
      <!-- =====第四步调整路线===== -->
      <el-tab-pane label="第四步调整路线" name="four" :disabled="disabled4">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList4">
          <div class="glo_btnList_left">
            <el-button v-if="pageType !== 'tzxl'" class="glo_btnItems glo_bgcMainColor" @click="nextStep4()">保存并下一步</el-button>
            <el-button v-if="pageType == 'tzxl'" class="glo_btnItems glo_bgcMainColor" @click="nextStep4('tzxl')">保存修改</el-button>
          </div>
          <div class="tujing">
            途径站点:
            <span style="color: #f00">{{ tableData4.length || 0 }}个</span>
          </div>
          <el-button class="glo_btnItems tabbleSetting" type="primary" @click="myModel()">表格设置</el-button>
        </div>

        <div class="glo_Table">
          <el-table :height="tableHeigth4" header-align="center" ref="mytable4" :data="tableData4" border stripe>
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <!-- <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>-->
            <template v-for="(item, index) in myTableHeard4">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" min-width="210">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button class="rbtns" v-if="scope.$index > 0" @click.stop="moveUp(scope.$index)">上移</el-button>
                  <el-button v-if="scope.$index !== tableData4.length - 1" class="rbtns" @click.stop="moveDown(scope.$index)">下移</el-button>
                  <el-button v-if="scope.$index > 0" class="rbtns" @click.stop="moveTop(scope.$index)">置顶</el-button>
                  <el-button v-if="scope.$index !== tableData4.length - 1" class="rbtns" @click.stop="moveBottom(scope.$index)">置底</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- =====第五步财务信息===== -->
      <el-tab-pane label="第五步财务信息" name="five" :disabled="disabled5">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList51">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="submits">保 存</el-button>
          </div>
        </div>

        <!-- <div class="h3title">财务应付</div> -->
        <!-- <div class="glo_btnList" ref="btnList52">
          <div class="glo_btnList_left">
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="openDialog('yf')"
              >添加应付
            </el-button>
          </div>
        </div>
        <div class="glo_Table">
          <el-table
            header-align="center"
            ref="mytable51"
            :data="tableData51"
            border
            stripe
            @selection-change="handleSelectionChange51"
            show-summary
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            >
            </el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard5">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              >
              </el-table-column>
            </template>
            <el-table-column
              label="操作"
              align="center"
              sortable
              min-width="80"
            >
              <template slot-scope="scope">
                <div>
                  <i
                    @click="delIconsYF(scope.$index)"
                    class="el-icon-delete iconsbtns"
                  ></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="h3title">财务应收</div>
       
        <div class="glo_btnList" ref="btnList52">
          <div class="glo_btnList_left">
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="openDialog('ys')"
              >添加应收
            </el-button>
          </div>
        </div>
        <div class="glo_Table">
          <el-table
            header-align="center"
            ref="mytable52"
            :data="tableData52"
            border
            stripe
            @selection-change="handleSelectionChange52"
            show-summary
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            >
            </el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard5">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              >
              </el-table-column>
            </template>
            <el-table-column
              label="操作"
              align="center"
              sortable
              min-width="80"
            >
              <template slot-scope="scope">
                <div>
                  <i
                    @click="delIconsYS(scope.$index)"
                    class="el-icon-delete iconsbtns"
                  ></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>-->

        <caiwuxinxi :tableDataYF="tableData51" :tableDataYS="tableData52" @delIconsYF="delIconsYF" @delIconsYS="delIconsYS" @diaConfirmBtnS="diaConfirmBtnS"></caiwuxinxi>
      </el-tab-pane>
    </el-tabs>

    <!-- 弹窗 查看货物明细 -->
    <myDialog :diaWidth="diaWidth3" :dialogTitle="dialogTitle3" :isShowDialog="isShowDialog3" @handleCloseDia="handleCloseDia3" @diaCancelBtn="handleCloseDia3" @diaConfirmBtn="diaConfirmBtn3()">
      <div class="glo_Table" v-if="isShowDialog3">
        <el-table header-align="center" :data="goodsNameData" border stripe>
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
          <template v-for="(item, index) in goodsTableHeard">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            ></el-table-column>
          </template>
        </el-table>
      </div>
    </myDialog>

    <!-- 弹窗 添加应收 -->
    <!-- <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItems"
            prop="inoutStatus"
            label="收支类型:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.inoutStatus"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="(item, index) in inoutStatusList"
                :key="index"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            prop="objectStatusType"
            label="结算对象:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm.objectStatusType"
                placeholder="请选择"
                @change="changeObjestStatusYS"
              >
                <el-option
                  v-for="(item, index) in objectStatusList"
                  :key="index"
                  :label="item.val"
                  :value="item.key"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm.objectName"
                placeholder="请选择"
                remote
                :allow-create="dialogForm.objectStatusType == 'other'"
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName1"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            prop="itemCategoryId"
            label="费项:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm.itemCategoryId"
                placeholder="请选择"
                @change="changeItemCategoryId"
              >
                <el-option
                  v-for="(item, index) in categoryNameList"
                  :key="index"
                  :label="item.categoryName"
                  :value="item.categoryId"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm.itemServiceId"
                placeholder="请选择"
                @change="changeItemServiceId"
              >
                <el-option
                  v-for="(item, index) in CategoryServiceList"
                  :key="index"
                  :label="item.title"
                  :value="item.itemServiceId"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="paymentMethodConfDictId"
            label="付款方式:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.paymentMethodConfDictId"
              placeholder="请选择"
              @change="changePayMent1"
              @focus="getConfDictValDownList('settlement_method')"
            >
              <el-option
                v-for="(item, index) in settlementMethodList"
                :key="index"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="amount" label="金额:">
            <el-input
              v-model="dialogForm.amount"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>-->

    <!-- 弹窗 添加应付 -->
    <!-- <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="diaCancelBtn2"
      @diaConfirmBtn="diaConfirmBtn2('dialogForm2Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm2Ref"
          v-if="isShowDialog2"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            class="dialogFormItems"
            prop="inoutStatus"
            label="收支类型:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm2.inoutStatus"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="(item, index) in inoutStatusList"
                :key="index"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            prop="objectStatusType"
            label="结算对象:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectStatusType"
                placeholder="请选择"
                @change="changeObjestStatus"
              >
                <el-option
                  v-for="(item, index) in objectStatusList"
                  :key="index"
                  :label="item.val"
                  :value="item.key"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectName"
                placeholder="请选择"
                remote
                :allow-create="dialogForm2.objectStatusType == 'other'"
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            prop="itemCategoryId"
            label="费项:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm2.itemCategoryId"
                placeholder="请选择"
                @change="changeItemCategoryIdYF"
              >
                <el-option
                  v-for="(item, index) in categoryNameList"
                  :key="index"
                  :label="item.categoryName"
                  :value="item.categoryId"
                ></el-option>
              </el-select>
              <el-select
                allow-create
                filterable
                clearable
                v-model="dialogForm2.itemServiceId"
                placeholder="请选择"
                @change="changeItemServiceId2"
              >
                <el-option
                  v-for="(item, index) in CategoryServiceList"
                  :key="index"
                  :label="item.title"
                  :value="item.itemServiceId"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="amount" label="金额:">
            <el-input
              type="number"
              v-model="dialogForm2.amount"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="paymentMethodConfDictId"
            label="付款方式:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm2.paymentMethodConfDictId"
              placeholder="请选择"
              @change="changePayMent"
              @focus="getConfDictValDownList('settlement_method')"
            >
              <el-option
                v-for="(item, index) in settlementMethodList"
                :key="index"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>-->

    <!-- 弹窗 更换车型 -->
    <myDialog
      :diaWidth="diaWidth4"
      :dialogTitle="dialogTitle4"
      :isShowDialog="isShowDialog4"
      @handleCloseDia="handleCloseDia4"
      @diaCancelBtn="handleCloseDia4"
      @diaConfirmBtn="diaConfirmBtn4('dialogForm4Ref')"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" ref="dialogForm4Ref" v-if="isShowDialog4" :model="dialogForm4" label-width="100px">
          <el-form-item class="dialogFormItems" prop="inoutStatus" label="车型:">
            <el-select filterable clearable v-model="dialogForm4.carTypeConfDictId" placeholder="请输入" @change="changeCarType4">
              <el-option v-for="item in car_type_list" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitleSet"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>
  </div>
</template>
<script>
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import paging from "@/components/pagings.vue"; //分页组件
import caiwuxinxi from "@/components/caiWuXinXi.vue";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
export default {
  inject: ["reload"],
  components: {
    multitime,
    myDialog,
    queryBtns,
    paging,
    caiwuxinxi,
    sorttable,
  },
  data() {
    return {
      activeName: "two",
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条

      pageStart2: 1, //  页码
      pageCount2: 0, //  总条数
      pageTotal2: 200, //  一页几条

      queryData: {
        waybillNumber: "",
        customerName: "",
        number: "",
        taskEndAllAddress: "",
        taskStartAllAddress: "",
        transportMethod: "",
        transportPlan: "",
        transportType: "",
      },
      oneDatas: {
        departureType: "",
        carTypeConfDictId: "",
        parentNumber: "",
      },

      disabled1: true,
      disabled2: false,
      disabled3: false,
      disabled4: false,
      disabled5: false,
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: true, //false == 更多条件  true ==收起条件

      // 时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "业务日期",
        },
        {
          value: "2",
          label: "提货日期",
        },
        {
          value: "3",
          label: "交货日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      tableHeigth2: "50vh", //第二步表格高度
      tableHeigth3: "72vh", //第三步表格高度
      tableHeigth4: "81vh", //第四步表格高度
      myTableHeard3: [
        {
          name: "任务编号",
          field: "memberNickname",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "会员号",
          field: "memberId",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "会员号",
          field: "memberId",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "会员号",
          field: "memberId",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard4: [
        {
          name: "类型",
          field: "addressTypeShow",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "任务单号",
          field: "taskNumber",
          width: "170",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "170",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "190",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "货物",
          field: "aaaa",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "状态",
          field: "loadStatusShow",
          width: "110",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "地址",
          field: "allAddress",
          width: "180",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard5: [
        {
          name: "费项",
          field: "itemServiceName",
          width: "110",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "金额",
          field: "amount",
          width: "110",
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "结算对象",
          field: "objectName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "付款方式",
          field: "paymentMethod",
          width: "110",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeardLeft: [
        {
          name: "货物",
          field: "goodsNames",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "任务编号",
          field: "number",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "运单号",
          field: "waybillNumber",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输计划",
          field: "transportPlanShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类",
          field: "itemCategoryName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积",
          field: "volume",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输方式",
          field: "transportMethodShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货地址",
          field: "taskStartAllAddress",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货地址",
          field: "taskEndAllAddress",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "状态",
          field: "taskStatusShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      myTableHeardLeft2: [
        // {
        //   name: "货物",
        //   field: "goodsNames",
        //   width: "120",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        {
          name: "任务编号",
          field: "number",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "运单号",
          field: "waybillNumber",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "品类",
          field: "itemCategoryName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包装",
          field: "packageName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "130",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/m³",
          field: "volume",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "开单备注",
          field: "remarks",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      goodsTableHeard: [
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货地址",
          field: "address",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物编号",
          field: "goodsNumber",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类",
          field: "itemCategoryName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包装",
          field: "packageName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积重量",
          field: "volumeWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "130",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/m³",
          field: "volume",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      goodsNameData: [],
      tableDataLeft: [], //  表格数据(左)
      tableDataRight: [], //  表格数据(右)
      tableDataRightUpdata: [], //修改前的数据
      tableData3: [
        {
          name: "测试",
          memberNickname: 23432434,
          memberId: "memberId",
        },
        {
          name: "1233333",
          memberNickname: 123,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 234,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
      ], //
      tableData51: [], //
      tableData52: [], //
      tableData4: [],
      delTb51: [],
      delTb52: [],

      selectTableData3: [],
      selectTableData4: [],
      selectTableData51: [],
      selectTableData52: [],
      selectTableDataLeft: [],
      selectTableDataRight: [],
      CategoryServiceList: [],

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "40%",
      dialogType: "",
      dialogForm: {
        // 弹窗表单数据
        amount: "",
        inoutStatus: "shou_ru:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethodConfDictName: "", //付款方式名称(我自己加的)
      },

      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog2: false,
      dialogTitle2: "",
      diaWidth2: "40%",
      dialogType2: "",
      editNum2: 0,
      dialogForm2: {
        amount: "",
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethod: "", //付款方式名称(我自己加的)
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog3: false,
      dialogTitle3: "货物信息",
      diaWidth3: "80%",
      dialogForm3: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog4: false,
      dialogTitle4: "更改车型",
      diaWidth4: "40%",
      dialogForm4: {
        // 弹窗表单数据
        carTypeConfDictId: "",
        CarTypeName: "",
      },
      // ==== 弹窗组件属性 end ====

      departure_type_list: [],
      car_type_list: [],
      transport_plan_list: [],
      transport_method_list: [],
      CustomerList: [],
      totalArr: [],
      dispatchId: "", //发车批次号id
      number_s: "", //编号(发车批次号)
      CarTypeName: "",

      categoryNameList: [],

      CustomerListsYF: [], //对象列表
      transportModeList: [], //运输方式
      ReceivingMethodList: [], //提货方式
      sendMethodList: [], //送货方式
      rnrderRequireList: [], //回单类型
      waybillTypeList: [], //货物类型
      objectStatusList: [], //结算对象类型
      settlementMethodList: [], //付款方式

      yesOrNoList: [
        {
          name: "是",
          val: "1",
        },
        {
          name: "否",
          val: "0",
        },
      ],
      inoutStatusList: [
        {
          name: "收入",
          val: "shou_ru:deal_status",
        },
        {
          name: "支出",
          val: "zhi_chu:deal_status",
        },
      ],
      rulesForm: {
        objectStatusType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        itemCategoryId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        paymentMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        amount: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      rulesForm2: {
        itemCategoryId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        itemServiceId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        objectStatusType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        paymentMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        amount: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      isPrint: false,
      pageType: "",
      isClick: false,

      show_sortTableHeard: false, //显示表格设置弹窗
      tabelHeadeTitleSet: [],
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      originalTabelHeadeTitle2: [],
      originalTabelHeadeTitle4: [],
      allCheck: false, //  全选
      sortName: "", //  排序名
      sortName2: "第二步表格设置", //  排序名
      sortName4: "第四步表格设置", //  排序名
      selectLength: 0, //  显示的长度
      pageGroupName2: "NewStowage2",
      pageGroupName4: "NewStowage4",
      isClick2: true,
      isClick4: true,
    };
  },
  watch: {
    activeName: function (a, b) {
      console.log(a);
      if (a === "two") {
        // this.pageStart = 1;
        // this.getData();
      }
      // if (a === "three") {

      // }
      if (a === "four") {
        this.getDispatchAddrList();

        if (this.isClick4) {
          let groupNames = this.pageGroupName4;
          this.getGroupFindFieldSort(groupNames);
          this.isClick4 = false;
        }
      }
      if (a === "five") {
        this.wtl_getDispatchFinance();
      }
    },
  },
  created() {
    let arrs = [];
    this.myTableHeardLeft2.forEach((item) => {
      if (item.isTotal) {
        arrs.push(item.field);
      }
    });
    this.totalArr = arrs;

    this.originalTabelHeadeTitle2 = JSON.parse(
      JSON.stringify(this.myTableHeardLeft)
    );
    this.originalTabelHeadeTitle4 = JSON.parse(
      JSON.stringify(this.myTableHeard4)
    );

    let groupNames = "";
    if (this.activeName == "two") {
      groupNames = this.pageGroupName2;
      this.getGroupFindFieldSort(groupNames);
    } else if (this.activeName == "four") {
      groupNames = this.pageGroupName4;
      this.getGroupFindFieldSort(groupNames);
    }
  },
  mounted() {
    this.getStatusValLists("bill_tms_dispatch_v3.departure_type"); // 发车类型
    this.getConfDictValDownLists("car_type"); //车型
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
  },
  activated() {
    let dispatchId = this.$route.query.dispatchId || "";
    let number_s = this.$route.query.number_s || "";
    let carType = this.$route.query.carType || "";
    this.pageType = this.$route.query.pageType || "";
    if (number_s) {
      this.number_s = number_s;
    }
    if (carType) {
      this.CarTypeName = carType;
    }
    if (dispatchId) {
      this.dispatchId = dispatchId;
      if (this.pageType == "tzxl") {
        // 线路调整
        this.disabled1 = true;
        this.disabled2 = true;
        this.disabled3 = true;
        this.disabled4 = false;
        this.disabled5 = true;
        this.activeName = "four";
        this.getDispatchAddrList();
      } else if (this.pageType == "Fee") {
        // 费用录入
        this.disabled1 = true;
        this.disabled2 = true;
        this.disabled3 = true;
        this.disabled4 = true;
        this.disabled5 = false;
        this.activeName = "five";
      } else {
        this.disabled1 = true;
        this.disabled2 = false;
        this.disabled3 = false;
        this.disabled4 = true;
        this.disabled5 = true;
        this.activeName = "two";
        this.getData();
        this.getData2();
      }
    }
  },
  destroyed() {},
  methods: {
    // 获取未调度的任务列表
    getData() {
      //
      let waybillNumbers = this.$TOOLS.getOrderNum(
        this.queryData.waybillNumber || ""
      );
      let startBusinessTime = "";
      let startCreateTime = "";
      let startDeliveryTime = "";
      let startTakeTime = "";

      let endBusinessTime = "";
      let endCreateTime = "";
      let endDeliveryTime = "";
      let endTakeTime = "";

      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";

      if (this.timeType == "0") {
        // 创建日期
        startCreateTime = startTime;
        endCreateTime = endTime;
      } else if (this.timeType == "1") {
        console.log("业务日期");
        // 业务日期
        startBusinessTime = startTime;
        endBusinessTime = endTime;
      } else if (this.timeType == "2") {
        // 提货日期
        startTakeTime = startTime;
        endTakeTime = endTime;
      } else if (this.timeType == "3") {
        // 交货日期
        startDeliveryTime = startTime;
        endDeliveryTime = endTime;
      }

      let param = {
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        customerName: this.queryData.customerName || "",
        number: this.queryData.number || "",
        taskEndAllAddress: this.queryData.taskEndAllAddress || "",
        taskStartAllAddress: this.queryData.taskStartAllAddress || "",
        transportMethod: this.queryData.transportMethod || "",
        transportPlan: this.queryData.transportPlan || "",
        transportType: this.queryData.transportType || "",
        waybillNumbers: waybillNumbers || [],
        endBusinessTime: endBusinessTime,
        endCreateTime: endCreateTime,
        endDeliveryTime: endDeliveryTime,
        endTakeTime: endTakeTime,
        startBusinessTime: startBusinessTime,
        startCreateTime: startCreateTime,
        startDeliveryTime: startDeliveryTime,
        startTakeTime: startTakeTime,
      };
      this.$API.wtl_getNoDispatchTaskList(param).then((res) => {
        this.tableDataLeft = res.data.result.data || [];
        this.pageCount = res.data.result.pageCount || 0;

        this.$nextTick(() => {
          this.fetTableHeight();
        });
      });
    },
    // 获取批次号任务列表
    getData2() {
      this.$API
        .wtl_getDispatchTaskList({
          dispatchId: this.dispatchId,
          pageStart: this.pageStart2,
          pageTotal: this.pageTotal2 || 200,
        })
        .then((res) => {
          this.tableDataRight = res.data.result.data || [];
          this.tableDataRightUpdata = res.data.result.data || [];
          this.pageCount2 = res.data.result.pageCount || 0;
        });
    },

    // 获取发车批次对应的装卸信息(路线调整)
    getDispatchAddrList() {
      this.$API
        .wtl_getDispatchAddrList({
          dispatchId: this.dispatchId,
        })
        .then((res) => {
          this.tableData4 = res.data.result.data || [];
        });
    },
    // 获取运输计划
    getTransPlan() {
      if (this.transport_plan_list.length > 0) {
        return false;
      }
      this.$TOOLS
        .getStatusValList("bill_tms_transport_task_v3.transport_plan")
        .then((res) => {
          this.transport_plan_list = res || [];
        });
    },
    // 获取运输方式
    getTransportMethod() {
      if (this.transport_method_list.length > 0) {
        return false;
      }
      this.$TOOLS
        .getStatusValList("bill_tms_transport_task_v3.transport_method")
        .then((res) => {
          this.transport_method_list = res || [];
        });
    },
    // 获取客户列表
    getCustomerList(name) {
      this.$COMAPI.getCustomerList(name).then((res) => {
        this.CustomerList = res || [];
      });
    },
    // 远程搜索客户
    getCustomerNames(e) {
      this.getCustomerList(e);
    },
    // 获取状态下拉列表
    getStatusValLists(val) {
      this.$TOOLS.getStatusValList(val).then((res) => {
        // 发车类型
        if (val == "bill_tms_dispatch_v3.departure_type") {
          this.departure_type_list = res || [];
        }
      });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownLists(val) {
      this.$COMAPI.getConfDictValDownList(val).then((res) => {
        //车型
        if (val == "car_type") {
          this.car_type_list = res || [];
        }
      });
    },
    // 选中车型
    changeCarType(e) {
      if (e) {
        this.car_type_list.forEach((item) => {
          if (item.confDictId == e) {
            this.CarTypeName = item.key;
          }
        });
      } else {
        this.CarTypeName = "";
      }
    },
    // 选中车型
    changeCarType4(e) {
      if (e) {
        this.car_type_list.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm4.CarTypeName = item.key;
          }
        });
      } else {
        this.dialogForm4.CarTypeName = "";
      }
    },
    //选择配置类型
    cahngeDepType(e) {
      console.log("e", e);
      if (e == "zheng_chang_fa_che:departure_type") {
        this.getConfDictValDownLists("car_type"); //车型
      }
      // else if (e == "yan_tu_zhuang_huo:departure_type") {

      // }
    },
    // 右移
    toRight() {
      if (this.selectTableDataLeft.length < 1) {
        this.$message.warning("请先选择左边列表的任务");
        return false;
      }
      let leftArrs = JSON.parse(JSON.stringify(this.tableDataLeft));
      for (var b = 0; b < this.selectTableDataLeft.length; b++) {
        for (var a = 0; a < leftArrs.length; a++) {
          if (leftArrs[a].taskId == this.selectTableDataLeft[b].taskId) {
            leftArrs.splice(a, 1);
            a--;
          }
        }
      }

      this.tableDataLeft = leftArrs;

      let arrs = JSON.parse(JSON.stringify(this.tableDataRight)) || [];
      arrs = arrs.concat(this.selectTableDataLeft);
      this.tableDataRight = arrs;
    },
    // 左移
    toLeft() {
      if (this.selectTableDataRight.length < 1) {
        this.$message.warning("请先选择右边列表的任务");
        return false;
      }
      let rightArrs = JSON.parse(JSON.stringify(this.tableDataRight));
      for (var b = 0; b < this.selectTableDataRight.length; b++) {
        for (var a = 0; a < rightArrs.length; a++) {
          if (rightArrs[a].taskId == this.selectTableDataRight[b].taskId) {
            rightArrs.splice(a, 1);
            a--;
          }
        }
      }

      this.tableDataRight = rightArrs;

      let arrs = JSON.parse(JSON.stringify(this.tableDataLeft)) || [];
      arrs = arrs.concat(this.selectTableDataRight);
      this.tableDataLeft = arrs;
    },

    // // 新建应付应收
    // openDialog(val) {
    //   if (val == "yf") {
    //     this.dialogTitle2 = "新建应付费项";
    //     this.isShowDialog2 = true;
    //     this.dialogType2 = "add";
    //     this.itemCategorChoose(); //费型类型下拉列表
    //     this.getConfDictValDownList("object_status"); //结算对象类型
    //     // 应付
    //   } else if (val == "ys") {
    //     // 应收
    //     this.dialogTitle = "新建应收费项";
    //     this.dialogType = "add";
    //     this.isShowDialog = true;
    //     this.itemCategorChoose(); //费型类型下拉列表
    //     this.getConfDictValDownList("object_status"); //结算对象类型
    //   }
    // },
    // // 编辑应付
    // editYF(val, idx) {
    //   this.itemCategorChoose(); //费型类型下拉列表
    //   this.getConfDictValDownList("object_status"); //结算对象类型
    //   this.dialogForm2 = val;
    //   console.log(val, "val");

    //   this.dialogTitle2 = "编辑应付费项";
    //   this.isShowDialog2 = true;
    //   this.dialogType2 = "edit";
    //   this.editNum2 = idx;
    // },
    // //选择费项类型(应收)
    // changeItemCategoryId(e) {
    //   if (e) {
    //     this.wtl_itemServiceListAll(e, "shou:direction_status");
    //     this.categoryNameList.forEach((item) => {
    //       if (item.categoryId == e) {
    //         this.dialogForm.itemCategoryName = item.categoryName;
    //       }
    //     });
    //   } else {
    //     this.dialogForm.itemServiceId = "";
    //     this.dialogForm.amount = "";
    //     this.dialogForm.itemServiceName = "";
    //   }
    // },
    // //选择费项
    // changeItemServiceId(e) {
    //   if (e) {
    //     this.CategoryServiceList.forEach((item) => {
    //       if (item.itemServiceId == e) {
    //         this.dialogForm.amount = item.unitPrice;
    //         this.dialogForm.itemServiceName = item.title;
    //       }
    //     });
    //   } else {
    //     this.dialogForm.amount = "";
    //     this.dialogForm.itemServiceName = "";
    //   }
    // },
    // // 费型类型下拉列表
    // itemCategorChoose(categoryName) {
    //   this.$API
    //     .itemCategorChoose({ categoryName: categoryName })
    //     .then((res) => {
    //       this.categoryNameList = res.data.result || [];
    //     });
    // },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
            this.goodsInfoList[0].itemReqs[0].packageNameList = arrs;
          }
          if (dictType == "waybill_type") {
            // 货物类型
            this.waybillTypeList = arrs;
          }
          if (dictType == "rn_order_require") {
            // 回单类型
            this.rnrderRequireList = arrs;
          }
          if (dictType == "send_method") {
            // 获取送货方式列表
            this.sendMethodList = arrs;
          }
          if (dictType == "receive_method") {
            // 获取收货方式列表
            this.ReceivingMethodList = arrs;
          }
          if (dictType == "transport_method") {
            // 获取运输方式列表
            this.transportModeList = arrs;
          }
          if (dictType == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = arrs;
          }
          if (dictType == "settlement_method") {
            // 获取付款方式
            this.settlementMethodList = arrs;
          }
        });
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        // this.$refs.mytable.doLayout();
        if (this.activeName == "two") {
          this.$refs.mytable.doLayout();
        } else if (this.activeName == "four") {
          this.$refs.mytable4.doLayout();
        }
      });
      return sums;
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        amount: "",
        inoutStatus: "shou_ru:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethodConfDictName: "", //付款方式名称(我自己加的)
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let objs = JSON.parse(JSON.stringify(this.dialogForm));
          if (this.dialogType == "add") {
            objs.operationType = "ADD";
            console.log("objs1", objs);
            this.tableData52.push(objs);
            this.isShowDialog = false;
          }
          // let datas = JSON.parse(JSON.stringify(this.dialogForm));
          // let items = {
          //   amount: datas.amount,
          //   itemCategoryId: datas.itemCategoryId,
          //   itemCategoryName: datas.itemCategoryName,
          //   itemServiceId: datas.itemServiceId,
          //   itemServiceName: datas.itemServiceName,
          //   remarks: datas.remarks,
          //   objectStatusType: datas.objectStatusType,
          //   paymentMethod: datas.paymentMethod,
          // };
          // if (this.dialogType == "add") {
          //   // 判断是否存在
          //   let flag = false;
          //   this.tableData52.forEach((item) => {
          //     if (item.itemServiceId == items.itemServiceId) {
          //       flag = true;
          //     }
          //   });

          //   if (flag) {
          //     this.$message.warning("该费项已存在");
          //     return false;
          //   } else {
          //     this.tableData52.push(items);

          //     this.$message.success("添加成功");
          //   }

          //   this.isShowDialog = false;
          // }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        amount: "",
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethod: "", //付款方式名称(我自己加的)
      };
    },
    //  弹窗确认保存事件(应付)
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let objs = JSON.parse(JSON.stringify(this.dialogForm2));
          if (this.dialogType2 == "add") {
            objs.operationType = "ADD";
            this.tableData51.push(objs);
            this.isShowDialog2 = false;
          } else {
            objs.operationType = "UPDATE";
            this.isShowDialog2 = false;
            let datas = JSON.parse(JSON.stringify(this.tableData51));
          }
          console.log("this.tableData51", this.tableData51);
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    handleCloseDia3() {
      this.isShowDialog3 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn3() {
      this.isShowDialog3 = false;
    },

    handleCloseDia4() {
      this.isShowDialog4 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn4() {
      this.$API
        .wtl_updateCarType({
          carTypeConfDictId: this.dialogForm4.carTypeConfDictId,
          dispatchId: this.dispatchId,
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.CarTypeName = this.dialogForm4.CarTypeName;
        });
      this.isShowDialog4 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 下移
    moveDown(idx) {
      // 防止连续点击
      if (this.isClick) {
        return false;
      } else {
        this.isClick = true;
        let that = this;
        setTimeout(() => {
          that.isClick = false;
        }, 600);
      }
      let newArrs = JSON.parse(JSON.stringify(this.tableData4));
      let itemp = this.tableData4[idx + 1];
      let item = this.tableData4[idx];
      newArrs[idx + 1] = item;
      newArrs[idx] = itemp;
      this.tableData4 = newArrs;
    },
    // 上移
    moveUp(idx) {
      // 防止连续点击
      if (this.isClick) {
        return false;
      } else {
        this.isClick = true;
        let that = this;
        setTimeout(() => {
          that.isClick = false;
        }, 600);
      }
      let newArrs = JSON.parse(JSON.stringify(this.tableData4));
      let itemp = this.tableData4[idx - 1];
      let item = this.tableData4[idx];
      newArrs[idx - 1] = item;
      newArrs[idx] = itemp;
      this.tableData4 = newArrs;
    },
    // 置顶
    moveTop(idx) {
      // 防止连续点击
      if (this.isClick) {
        return false;
      } else {
        this.isClick = true;
        let that = this;
        setTimeout(() => {
          that.isClick = false;
        }, 600);
      }
      let newArrs = JSON.parse(JSON.stringify(this.tableData4)) || [];
      let item = this.tableData4[idx];
      newArrs.splice(idx, 1);
      newArrs.unshift(item);
      this.tableData4 = newArrs;
    },
    // 置底
    moveBottom(idx) {
      // 防止连续点击
      if (this.isClick) {
        return false;
      } else {
        this.isClick = true;
        let that = this;
        setTimeout(() => {
          that.isClick = false;
        }, 600);
      }
      let newArrs = JSON.parse(JSON.stringify(this.tableData4)) || [];
      let item = this.tableData4[idx];
      newArrs.splice(idx, 1);
      newArrs.push(item);
      this.tableData4 = newArrs;
    },
    // 查看货物明细:
    getGoodsNameDetails(row) {
      console.log("row", row);

      // this.dialogForm2 = row;
      // this.$API.wtl_getWaybillAddrItems({ addrId: row.takeAddrId }).then((res) => {
      //   this.goodsNameData = res.data.result || [];
      //   this.isShowDialog3 = true;
      // });
      this.$API.wtl_getTaskItems({ taskId: row.taskId }).then((res) => {
        this.goodsNameData = res.data.result || [];
        this.isShowDialog3 = true;
      });
    },
    goYdDetails() {},
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    rowclick2(row, event, column) {
      this.$refs.mytable2.toggleRowSelection(row);
    },
    // 表格选择事件(左表格)
    handleSelectionChange(e) {
      this.selectTableDataLeft = e;
    },
    // 表格选择事件(第二步右表格)
    handleSelectionChange2(e) {
      this.selectTableDataRight = e;
    },
    // 表格选择事件(第三步)
    handleSelectionChange3(e) {
      this.selectTableData3 = e;
    },
    // // 表格选择事件(第四步)
    // handleSelectionChange4(e) {
    //   this.selectTableData4 = e;
    // },
    // 表格选择事件(第五步,应付)
    handleSelectionChange51(e) {
      this.selectTableData51 = e;
    },
    // 表格选择事件(第五步,应收)
    handleSelectionChange52(e) {
      this.selectTableData52 = e;
    },
    // 下一步
    nextStep(e) {
      if (e == 1) {
        this.activeName = "two";
      }
      if (e == 2) {
        this.activeName = "three";
      }
      if (e == 3) {
        this.activeName = "four";
      }
      if (e == 4) {
        this.activeName = "five";
      }
    },

    // 初始化生成任务批次号
    createRenWu() {
      let that = this;
      let param = JSON.parse(JSON.stringify(this.oneDatas));
      this.$API.wtl_initDispatch(param).then((res) => {
        this.$message.success(res.data.message || "新建成功").showClose = true;
        this.dispatchId = res.data.result.dispatchId || "";
        this.number_s = res.data.result.number || "";
        setTimeout(() => {
          that.$message.closeAll();
          that.activeName = "two";
          that.disabled1 = true;
          that.disabled2 = false;
          that.pageStart = 1;
          that.getData();
        }, 1000);
      });
    },
    // 保存第二步的任务
    nextStep2() {
      // if (this.tableDataRight.length < 1) {
      //   this.$message.error(
      //     "还没有选择任务,请先把需要配载的任务移到右边"
      //   ).showClose = true;
      //   return false;
      // }
      this.activeName = "three";
      this.disabled2 = false;
      this.disabled3 = false;
    },
    // 保存任务

    nextStep3() {
      let that = this;
      let taskInfoReqs = [];
      let tableDataRight = JSON.parse(JSON.stringify(this.tableDataRight));
      let tableDataRightUpdata = JSON.parse(
        JSON.stringify(this.tableDataRightUpdata)
      );

      tableDataRightUpdata.forEach((item, index) => {
        item.operationType = "UNCHANGED";
      });

      let ids1 = tableDataRightUpdata.map((item) => {
        return item.taskId;
      });
      let ids2 = tableDataRight.map((item) => {
        return item.taskId;
      });
      // [1,2,3,4,5]   [2,3,4,5,6]
      // 把原来的数组跟修改后的对比,找出删除的
      for (var a = 0; a < tableDataRightUpdata.length; a++) {
        if (ids2.indexOf(tableDataRightUpdata[a].taskId) == -1) {
          tableDataRightUpdata[a].operationType = "DEL";
        }
      }
      // 把修改后的数组跟原来的对比,找出新增的
      let addArrs = [];
      for (var b = 0; b < tableDataRight.length; b++) {
        if (ids1.indexOf(tableDataRight[b].taskId) == -1) {
          tableDataRight[b].operationType = "ADD";
          addArrs.push(tableDataRight[b]);
        }
      }
      //把原来的数组加上新增的数组
      tableDataRightUpdata = tableDataRightUpdata.concat(addArrs);
      //
      tableDataRightUpdata.forEach((item, index) => {
        let objs = {
          operationType: item.operationType,
          sort: index + 1,
          taskId: item.taskId,
        };
        taskInfoReqs.push(objs);
      });

      let param = {
        dispatchId: this.dispatchId,
        taskInfoReqs: taskInfoReqs,
      };
      this.$API.wtl_saveDispatchTask(param).then((res) => {
        this.$message.success(res.data.message || "保存成功").showClose = true;
        setTimeout(() => {
          that.$message.closeAll();
          that.activeName = "four";
          // that.disabled2 = true;
          // that.disabled3 = true;
          that.disabled4 = false;
          that.disabled5 = false;
        }, 1000);
      });
    },
    // 第四步保存
    nextStep4(type) {
      let that = this;
      let routeLineReqs = [];
      let data4 = JSON.parse(JSON.stringify(this.tableData4 || []));
      data4.forEach((item, index) => {
        let objs = {
          routeId: item.routeId,
          sort: index + 1,
        };
        routeLineReqs.push(objs);
      });
      this.$API
        .wtl_saveDispatchRoute({ routeLineReqs: routeLineReqs })
        .then((res) => {
          this.$message.success(
            res.data.message || "保存成功"
          ).showClose = true;
          setTimeout(() => {
            that.$message.closeAll();
            if (type == "tzxl") {
            } else {
              that.activeName = "five";
            }

            that.disabled4 = false;
            that.disabled5 = false;
          }, 1000);
        });
    },
    // 财务信息组件
    delIconsYF(e, array1) {
      this.delTb51 = e || [];
      this.tableData51 = array1;
    },
    delIconsYS(e, array2) {
      this.delTb52 = e || [];
      this.tableData52 = array2;
    },
    diaConfirmBtnS(array1, array2) {
      this.tableData51 = array1;
      this.tableData52 = array2;
    },
    // 保存财务信息
    submits() {
      let data1 = JSON.parse(JSON.stringify(this.tableData51)) || [];
      let data2 = JSON.parse(JSON.stringify(this.tableData52)) || [];
      let delTb51 = JSON.parse(JSON.stringify(this.delTb51)) || [];
      let delTb52 = JSON.parse(JSON.stringify(this.delTb52)) || [];

      let financeOutReqs = [...data1, ...delTb51];
      let financeInReqs = [...data2, ...delTb52];

      // financeInReqs.forEach((item) => {
      //   item.operationType = "UPDATE";
      // });
      // financeOutReqs.forEach((item) => {
      //   item.operationType = "UPDATE";
      // });

      let param = {
        dispatchId: this.dispatchId,
        financeInReqs: financeInReqs,
        financeOutReqs: financeOutReqs,
      };
      this.$API.wtl_saveDispatchFinance(param).then((res) => {
        this.$message.success(res.data.message || "保存成功");
        this.delTb51 = [];
        this.delTb52 = [];
        this.$TOOLS.closePage();
        this.$router.push({
          path: "/DispatchCar/VehicleStowage",
          query: {
            isreload: "isreload",
          },
        });

        // this.$confirm("保存成功!", "提示:", {
        //   confirmButtonText: "继续新建",
        //   cancelButtonText: "返回司机调度列表",
        // })
        //   .then(() => {
        //     this.reload(); //清空页面,这里不应该刷新页面的,有空回头改
        //   })
        //   .catch(() => {
        //     this.$TOOLS.closePage(this);
        //     this.$router.push({
        //       path: "/DispatchCar/VehicleStowage",
        //     });
        //   });
      });
    },
    // 获取财务信息
    wtl_getDispatchFinance() {
      this.$API
        .wtl_getDispatchFinance({ dispatchId: this.dispatchId })
        .then((res) => {
          let financeInReqs = res.data.result.financeInVos || []; //应收
          let financeOutReqs = res.data.result.financeOutVos || []; //应付

          financeInReqs.forEach((item) => {
            item.operationType = "UPDATE";
          });
          financeOutReqs.forEach((item) => {
            item.operationType = "UPDATE";
          });

          this.tableData51 = financeOutReqs;
          this.tableData52 = financeInReqs;
        });
    },
    // 更改车型
    updateCarType() {
      this.isShowDialog4 = true;

      // CarTypeName
      this.car_type_list.forEach((item) => {
        if (item.key == this.CarTypeName) {
          this.dialogForm4.carTypeConfDictId = item.confDictId;
        }
      });
    },

    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm2.objectNumber = item.number;
            this.dialogForm2.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    changeobjectName1(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm.objectNumber = item.number;
            this.dialogForm.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },

    // 选择结算对象类型(应收
    changeObjestStatusYS(e) {
      this.dialogForm.objectName = "";
      if (e) {
        this.getObjectUserDownListYf();
      } else {
        this.dialogForm.objectName = "";
        this.dialogForm.objectNumber = "";
        this.dialogForm.objectStatusConfDictId = "";
      }
    },
    // 选择结算对象类型(应付)
    changeObjestStatus(e) {
      this.dialogForm2.objectName = "";
      if (e) {
        this.getObjectUserDownListYf();
      } else {
        this.dialogForm2.objectName = "";
        this.dialogForm2.objectNumber = "";
        this.dialogForm2.objectStatusConfDictId = "";
      }
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      let objectStatusType = "";
      if (this.isShowDialog) {
        objectStatusType = this.dialogForm.objectStatusType;
      } else {
        objectStatusType = this.dialogForm2.objectStatusType;
      }

      this.$API
        .wtl_getObjectUserDownList({
          key: objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    //选择费项(应付弹窗)
    changeItemServiceId2(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm2.amount = item.unitPrice;
            this.dialogForm2.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm2.amount = "";
        this.dialogForm2.itemServiceName = "";
      }
    },
    //选择付款方式(应付弹窗)
    changePayMent1(e) {
      if (e) {
        this.settlementMethodList.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm.paymentMethod = item.val;
          }
        });
      } else {
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    //选择付款方式(应付弹窗)
    changePayMent(e) {
      if (e) {
        this.settlementMethodList.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm2.paymentMethod = item.val;
          }
        });
      } else {
        this.dialogForm2.amount = "";
        this.dialogForm2.itemServiceName = "";
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },

    //选择费项类型(应付)
    changeItemCategoryIdYF(e) {
      if (e) {
        this.wtl_itemServiceListAll(e, "fu:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm2.itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.dialogForm2.itemServiceId = "";
        this.dialogForm2.amount = "";
        this.dialogForm2.itemServiceName = "";
      }
    },

    // // 删除应付
    // delIconsYF(idx) {
    //   this.$confirm("确定要删除该行信息吗?", "提示:")
    //     .then(() => {
    //       let datas = JSON.parse(JSON.stringify(this.tableData51)) || [];
    //       let delTb51 = JSON.parse(JSON.stringify(this.delTb51)) || [];
    //       if (datas[idx].operationType !== "ADD") {
    //         datas[idx].operationType = "DEL";
    //         delTb51.push(datas[idx]);
    //         this.delTb51 = delTb51;
    //       }
    //       datas.splice(idx, 1);
    //       this.tableData51 = datas;
    //     })
    //     .catch(() => {});
    // },
    // // 删除应收
    // delIconsYS(idx) {
    //   this.$confirm("确定要删除该行信息吗?", "提示:")
    //     .then(() => {
    //       let datas = JSON.parse(JSON.stringify(this.tableData52)) || [];
    //       let delTb52 = JSON.parse(JSON.stringify(this.delTb52)) || [];
    //       if (datas[idx].operationType !== "ADD") {
    //         datas[idx].operationType = "DEL";
    //         delTb52.push(datas[idx]);
    //         this.delTb52 = delTb52;
    //       }
    //       datas.splice(idx, 1);
    //       this.tableData52 = datas;
    //     })
    //     .catch(() => {});
    // },

    // 点击tabs切换
    tabsClick(e) {
      // this.pageStart = 1;
      // if (e.name == "one") {
      // } else if (e.name == "two") {
      //   this.$nextTick(() => {
      //     this.fetTableHeight();
      //   });
      // } else if (e.name == "three") {
      // } else if (e.name == "four") {
      // }
    },

    printClick() {
      let that = this;
      this.isPrint = true;
      setTimeout(() => {
        that.$print(this.$refs.print);
      }, 300);
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {};
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },
    handleSizeChange2(val) {
      //  分页
      this.pageTotal2 = val;
      this.getData2();
    },
    handleCurrentChange2(val) {
      //  分页
      this.pageStart2 = val;
      this.getData2();
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tableHeigth2 = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight || 40; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight =
        queryHeigth + btnListHeight + pagsHeigth + 60 + 50 + 40 + 10; //60是顶部导航 50是tabs 40是表格上面已选择未选择的标题
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth2 = tabHeight;
        this.$refs.mytable.doLayout();
        this.$refs.mytable2.doLayout();
      });
    },

    // ===================排序表头彈窗的组件方法 start ===================

    //  设置模板按钮
    myModel() {
      let that = this;

      let tabelHeadeTitleSet = [];
      if (this.activeName == "two") {
        tabelHeadeTitleSet = JSON.parse(JSON.stringify(that.myTableHeardLeft));
        this.originalTabelHeadeTitle = this.originalTabelHeadeTitle2;
        this.sortName = this.sortName2;
      } else if (this.activeName == "four") {
        tabelHeadeTitleSet = JSON.parse(JSON.stringify(that.myTableHeard4));
        this.originalTabelHeadeTitle = this.originalTabelHeadeTitle4;
        this.sortName = this.sortName4;
      }

      let selectLength = 0;
      for (var i = 0; i < tabelHeadeTitleSet.length; i++) {
        if (tabelHeadeTitleSet[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength === tabelHeadeTitleSet.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
      that.tabelHeadeTitleSet = tabelHeadeTitleSet;
      that.show_sortTableHeard = true;
    },

    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        if (this.activeName == "two") {
          this.$refs.mytable.doLayout();
        } else if (this.activeName == "four") {
          this.$refs.mytable4.doLayout();
        }
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitleSet = e;

      let sortObject = this.tabelHeadeTitleSet;
      let param = {};
      if (this.activeName == "two") {
        param = {
          groupName: this.pageGroupName2, //当前页面表格的标记(自定义字符串)
          sortName: this.sortName2, //综合查询接口路径
          sortObject: JSON.stringify(sortObject),
        };
        this.myTableHeardLeft = this.tabelHeadeTitleSet;
      } else if (this.activeName == "four") {
        param = {
          groupName: this.pageGroupName4, //当前页面表格的标记(自定义字符串)
          sortName: this.sortName4, //综合查询接口路径
          sortObject: JSON.stringify(sortObject),
        };
        this.myTableHeard4 = this.tabelHeadeTitleSet;
      }

      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.getGroupFindFieldSort(param.groupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        if (this.activeName == "two") {
          this.$refs.mytable.doLayout();
        } else if (this.activeName == "four") {
          this.$refs.mytable4.doLayout();
        }
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitleSet[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitleSet.length; i++) {
        if (that.tabelHeadeTitleSet[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitleSet.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitleSet.length; j++) {
        this.tabelHeadeTitleSet[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitleSet.length; i++) {
        if (that.tabelHeadeTitleSet[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    //    -------------  设置列表表头方法  ------------

    getGroupFindFieldSort(pageGroupName) {
      //  获取自定义的排序,没有就用默认的
      this.$API
        .getGroupFindFieldSort({
          groupName: pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          let arrs = [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              arrs = JSON.parse(arr[0].sortObject);
              console.log("arrsaaaa", arrs);

              if (this.activeName == "one") {
                this.sortName1 = arr[0].sortName;
                this.tabelHeadeTitle = arrs;
              } else if (this.activeName == "two") {
                this.sortName2 = arr[0].sortName;
                this.tabelHeadeTitle2 = arrs;
              } else if (this.activeName == "three") {
                this.sortName3 = arr[0].sortName;
                this.tabelHeadeTitle3 = arrs;
              }
            }
          } else {
            if (this.activeName == "one") {
              arrs = this.tabelHeadeTitle;
            } else if (this.activeName == "two") {
              arrs = this.tabelHeadeTitle2;
            } else if (this.activeName == "three") {
              arrs = this.tabelHeadeTitle3;
            }
          }

          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < arrs.length; i++) {
            if (arrs[i].isTotal) {
              totalArr.push(arrs[i].field);
            }
          }
          this.totalArr = totalArr;
          if (this.activeName == "two") {
            this.$nextTick(() => {
              this.$refs.mytable.doLayout();
              this.myTableHeardLeft = arrs;
            });
          } else if (this.activeName == "four") {
            this.$nextTick(() => {
              this.$refs.mytable4.doLayout();
              this.myTableHeard4 = arrs;
            });
          }
        });
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
};
</script>
<style scoped lang='less'>
.creatBtns {
  padding: 10px;
  margin-top: 30px;
}

/deep/ .glo_form .itemPch .el-form-item__label {
  width: 140px !important;
}

.glo_form .itemPch {
  width: 330px !important;
}

.ShuttleTable {
  width: 100%;
  display: flex;
  justify-content: space-between;
  min-height: 50vh;

  .centerBtns {
    width: 100px;
    // padding-top: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .glo_btnItems {
      margin: 30px auto 0;

      width: 80px;
      padding: 10px 4px;
    }
  }

  .leftTable,
  .rightTable {
    flex: 1;
    // background-color: #f00;
    max-width: calc(100% - 80px);
    overflow-x: auto;
  }
}

.tabTips {
  //   margin: 4px 10px 10px;
  font-weight: bold;
  background-color: #f2f2f2;
  padding: 6px;
}

.detailsBox {
  display: flex;
  flex-wrap: wrap;
  background-color: #f2f2f2;
  padding: 10px 10px 0;
  font-size: 16px;

  .item {
    display: flex;
    margin-right: 40px;
    min-width: 180px;
    margin-bottom: 10px;

    .dItemLabel {
      margin-right: 10px;
    }
    .ditemBtn {
      color: #0000ff;
      margin-left: 20px;
    }
  }
}

.chongTu {
  color: #f00;
  margin: 10px 0;
}

.tujing {
  width: 100%;
  text-align: right;
  // margin-bottom: 10px;
}

// 查询条件边框线
@borderColor: #cccccc;

.h3title {
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid @borderColor;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}

.waybillNumbersss {
  flex: 1;
  /deep/ .el-form-item__content {
    width: 100%;
  }
  /deep/ .el-input__inner {
    width: 100%;
  }
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}
.iconsRight10 {
  margin-right: 10px;
}
.iconsbtns {
  font-size: 28px;
  cursor: pointer;
}

.tabbleSetting {
  margin-left: 20px;
  height: 28px;
  line-height: 28px;
  padding: 0 4px;
  background-color: #0390cf;
  color: #ffffff;
}
</style>